import React from "react";
import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { CtaGhost } from "@/components/CTA";

export function FormSuccess({ title = "REQUEST RECEIVED", copy, testId = "form-success" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
      className="border border-strike/40 bg-nearblack p-12 lg:p-16"
      data-testid={testId}
    >
      <div className="w-16 h-16 border border-strike flex items-center justify-center">
        <Check className="w-8 h-8 text-strike" />
      </div>
      <h2 className="font-display font-black uppercase tracking-tight text-4xl md:text-5xl text-offwhite mt-8">{title}</h2>
      <p className="text-mutedgray text-lg mt-6 max-w-xl leading-relaxed">{copy}</p>
      <div className="mt-10">
        <CtaGhost to="/" testId="success-home">Back to Home</CtaGhost>
      </div>
    </motion.div>
  );
}
